// SelectWidget.js
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Spinner } from "@chakra-ui/react";


const SelectWidget = ({
  id,
  value,
  required,
  onChange,
  label,
  fetchOptions,
  readonly,
  disabled,
  schema,
  uiSchema
}) => {
    const [options, setOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    
    // Check if the field should be readonly or disabled
    const isReadOnly = readonly || disabled || uiSchema?.["ui:readonly"] || uiSchema?.["ui:disabled"];

    useEffect(() => {
      const loadOptions = async () => {
        try {
          const result = await fetchOptions("");
          setOptions(result || []);
        } catch (error) {
          console.error('Error loading options:', error);
          setOptions([]);
        } finally {
          setIsLoading(false);
        }
      };
      loadOptions();
    }, [fetchOptions]);

    const handleChange = (selectedOption) => {
      if (isReadOnly) return; // Prevent changes if readonly
      onChange(selectedOption ? selectedOption.value : '');
    };
    
    return (
      <div>
        <label htmlFor={id} style={{ fontSize: "14px", marginBottom: "4px", display: "block" }}>
          {label} {required && <span style={{ color: "red" }}>*</span>}
        </label>
        {isReadOnly ? (
          // If readonly, render as plain text
          <div style={{ 
            padding: "8px 12px", 
            border: "1px solid #e2e8f0", 
            borderRadius: "4px", 
            backgroundColor: "#f8f9fa",
            color: "#718096"
          }}>
            {value || ""}
          </div>
        ) : isLoading ? (
          <div style={{ padding: "8px 12px" }}>
            <Spinner size="sm" />
          </div>
        ) : (
          // Render the regular Select
          <Select
            id={id}
            options={options}
            value={value ? { label: value, value } : null}
            onChange={handleChange}
            placeholder="Select an option..."
            isClearable={true}
            isSearchable={true}
          />
        )}
      </div>
    );
};

export default SelectWidget;

